import { osName } from 'react-device-detect';

// Import helpers
import services from 'services/services';

// Import types
import { SubscriberApi } from 'helpers/api/subscriber_api';
import type { AgreementsAcceptParams } from 'types/views/agreements';
import type { SubscriberDetails, ParentalControlResponse, DeviceListResponse } from 'types/api/subscriber';

export const fetchSubscriberProductsUuids = async (isAuth = true) => {
	if (!isAuth) return [];

	try {
		const response = await services.get<{ data: string[] }>(SubscriberApi.ProductsUuids);
		return response.data.data;
	} catch (err) {
		return [];
	}
};

export const addSubscriberDeviceName = (name = osName) => services.post(SubscriberApi.DeviceName, { name });

export const subscriberAgreementsAccept = ({ agreement_version_ids, token }: AgreementsAcceptParams) => {
	const authorization = token ? `Bearer ${token}` : null;
	return services.post(SubscriberApi.AgreementsAccept, { agreement_version_ids }, { headers: { Authorization: authorization } });
};

export const subscriberDetails = () => services.get<SubscriberDetails>(SubscriberApi.Details).then((response) => response.data);

export const logout = async (isAuth = true, thunkAPI: any) => {
	try {
		if (isAuth) {
			await services.post(SubscriberApi.Logout);
		} else {
			thunkAPI.fulfillWithValue(true);
		}
	} catch (error) {
		return error;
	}
};

export const subscriberActiveDevices = async (token?: string) => {
	try {
		const authorization = token ? `Bearer ${token}` : null;
		const response = await services.get<DeviceListResponse>(SubscriberApi.ActiveDevices, { headers: { Authorization: authorization } });
		return response.data.data;
	} catch (error) {
		return [];
	}
};

export const subscriberHideUnavailable = (hide: boolean) => services.put(SubscriberApi.HideUnavailable, { hide });

export const subscriberParentalDisable = async (pin: string) => services.post<ParentalControlResponse>(SubscriberApi.ParentalDisable, { pin });

export const subscriberParentalEnable = async (rating: number) => services.post<ParentalControlResponse>(SubscriberApi.ParentalEnable, { rating });

export const subscriberVerificationDocumentUpload = (formdata: FormData) =>
	services.post(SubscriberApi.VerificationDocumentUpload, formdata, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});

export const subscriberInLocal = async () => services.get<{ value: false }>(SubscriberApi.InLocal).then((response) => response.data.value);
